const SIMPLE_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

/**
 * Returns a Swedish error message if the email is invalid, or null if valid.
 * Stricter than native `type="email"` validation, which accepts addresses
 * without a real domain/TLD (e.g. "hej@hej.").
 */
export const validateEmail = (email: string): string | null => {
  const trimmedEmail = email.trim();

  if (!trimmedEmail) {
    return "Fyll i din e-postadress i formatet email@email.com";
  }

  if (!trimmedEmail.includes("@")) {
    return "E-postadressen saknar @. Fyll i din e-postadress i formatet email@email.com";
  }

  if (!trimmedEmail.split("@")[1]?.includes(".")) {
    return "E-postadressen saknar en punkt, fyll i din e-postadress i formatet: email@email.com";
  }

  if (!SIMPLE_EMAIL_REGEX.test(trimmedEmail)) {
    return "Ogiltig e-postadress. Fyll i din e-postadress i formatet email@email.com";
  }

  return null;
};
